import { render } from "./CustomConfirm.vue.vue?vue&type=template&id=908fe1da&scoped=true"
import script from "./CustomConfirm.vue.vue?vue&type=script&lang=js"
export * from "./CustomConfirm.vue.vue?vue&type=script&lang=js"

import "./CustomConfirm.vue.vue?vue&type=style&index=0&id=908fe1da&scoped=true&lang=css"

import exportComponent from "/home/cpaps/dev2-sistema-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-908fe1da"]])

export default __exports__